import { render, staticRenderFns } from "./TopicsIndex.vue?vue&type=template&id=50732c15&scoped=true"
import script from "./TopicsIndex.vue?vue&type=script&lang=js"
export * from "./TopicsIndex.vue?vue&type=script&lang=js"
import style0 from "./TopicsIndex.vue?vue&type=style&index=0&id=50732c15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50732c15",
  null
  
)

export default component.exports